import React from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.arrayOf(PropTypes.node)
        ]).isRequired,
        render: PropTypes.func.isRequired
    }

    state = {
        hasError: false,
        error: null,
        errorInfo: null
    }

    static getDerivedStateFromError = () => {
        return { hasError: true };
    };

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error,
            errorInfo
        });
    }

    render() {
        const { hasError, error, errorInfo } = this.state;
        return hasError
            ? (
                <div className="alert alert-danger">
                    <h4>Oops, error occoured!</h4>
                    {this.props.render(error, errorInfo)}
                </div>
            ) : this.props.children;
    }
}
